export default "./../../assets/images/email/uq-logo.png";